import React from 'react';
import Checkbox from '@mui/material/Checkbox';

import { useEditWorker } from 'features/workers';

interface PhotoQcCheckboxProps {
  workerId: number;
  checked: boolean;
  disabled?: boolean;
}

const PhotoQcCheckbox = ({ workerId, checked, disabled }: PhotoQcCheckboxProps) => {
  const { mutate: editWorkerMutation, isPending } = useEditWorker();

  const handleChange = () => {
    editWorkerMutation({ id: workerId, data: { isPhotoQcRequired: !checked } });
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      disabled={disabled || isPending}
      size="small"
    />
  );
};

export default PhotoQcCheckbox;
